import { Modal } from '@prio365/prio365-react-library';
import { notification } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IncomingInvoiceDto } from '../../../../../../models/IncomingInvoices';
import { makePrioStyles } from '../../../../../../theme/utils';
import { apiTriggerOCRAnalysis } from '../../../../api';

const useStyles = makePrioStyles((theme) => ({
  root: {},
}));

interface IncomingInvoiceOCRTriggerModalProps {
  className?: string;
  visible: boolean;
  invoice: IncomingInvoiceDto;
  onClose: () => void;
  onDrawerClose: () => void;
  onActionComplete: () => void;
}

export const IncomingInvoiceOCRTriggerModal: React.FC<
  IncomingInvoiceOCRTriggerModalProps
> = (props) => {
  //#region ------------------------------ Defaults
  const {
    className,
    visible,
    invoice,
    onClose,
    onDrawerClose,
    onActionComplete,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const triggerOCRAnalysis = async () => {
    const ocrResult = await apiTriggerOCRAnalysis(
      invoice.incomingInvoiceId,
      'german'
    );
    if (ocrResult.result.status === 204 || ocrResult.result.ok) {
      notification.success({
        message: t('accounting:incomingInvoices.upload.uploadSuccess'),
        description: t(
          'accounting:incomingInvoices.upload.uploadSuccessDescription'
        ),
      });
      onClose();
      onDrawerClose();
      onActionComplete();
    } else {
      throw new Error(
        `OCR analysis failed with status: ${ocrResult.result.status}`
      );
    }
  };
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <Modal
      visible={visible}
      className={classNames(classes.root, className)}
      onClose={onClose}
      closable
      cancelText={t('accounting:incomingInvoices.drawer.cancel')}
      onOk={triggerOCRAnalysis}
      okText={t('accounting:incomingInvoices.drawer.repeatOCRAnalysis')}
      title={t('accounting:incomingInvoices.drawer.ocrModal.title')}
    >
      {t('accounting:incomingInvoices.drawer.ocrModal.description')}
    </Modal>
  );
};

export default IncomingInvoiceOCRTriggerModal;
